import { Container } from 'react-bootstrap';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/header';
import useLocation from './hooks/useLocation';
import Home from './components/home';
import Config from './components/config';
import NotFound from './components/notfound';
import Squad from './components/squad';
import Team from './components/team';
import { DataContextProvider } from './context/datacontext';
import Lineup from './components/lineups/lineup';



function App() {
  
  const { hash } = useLocation();

  return (
    <DataContextProvider>
    <Container fluid>
      <Header />
      {hash === "" && <Home />}
      {hash === "home" && <Home />}
      {hash === "config" && <Config />}
      {hash === "squad" && <Squad />}
      {hash === "team" && <Team />}
      {hash === "lineup" && <Lineup />}
    </Container>
    </DataContextProvider>
  );
}

export default App;
